<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Content Library</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_ASSET_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add Asset</a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control" placeholder="Filter by name" style="padding: 11px;">

      <app-dropdown-select [(ngModel)]="filters.values['productId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by brand" class="form-control">
        @for (product of products; track product.id) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['lang']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by lang" class="form-control">
        @for (lang of languages; track lang.isoCode) {
          <app-dropdown-select-option [value]="lang.isoCode">{{ lang.name }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['type']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by type" class="form-control">
        @for (type of assetTypes; track type) {
          <app-dropdown-select-option [value]="type.identifier">{{ type.label }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [(ngModel)]="filters.values['userId']" (onDropdownChange)="filters.onFilterChange()" [multiple]="true" placeholder="Filter by author" class="form-control">
        @for (user of users; track user.id) {
          <app-dropdown-select-option [value]="user.id">{{ user }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th></th>
          <th tableSorterHeader="name">Name</th>
          <th>Brand</th>
          <th>Language</th>
          <th tableSorterHeader="type">Type</th>
          <th tableSorterHeader="createdAt">Created</th>
          <th>Modified</th>
          <th tableSorterHeader="user">Author</th>
          <th class="text-end">Action</th>
        </tr>
        </thead>
        <tbody>
          @for (asset of assets; track asset.id) {
            <tr>
              <td>{{ asset.id }}</td>
              <td class="pb-0 pt-1">
                @if (asset.type === 'image' && asset.document) {
                  <img [src]="imageService.getImageUrl(asset.document, 48, 48, true)" alt="" width="48" height="48" class="rounded">
                } @else if (asset.type === 'video' && asset.document?.url) {
                  <video [src]="asset.document!.url!" width="48" height="48" class="rounded object-fit-cover" muted controls></video>
                }
              </td>
              <td>{{ asset.name }}</td>
              <td>{{ asset.product }}</td>
              <td>{{ asset.lang ?? 'All' }}</td>
              <td><span class="badge bg-secondary">{{ asset.type }}</span></td>
              <td>{{ asset.createdAt | date:'dd MMM yyyy' }}</td>
              <td>{{ asset.updatedAt | date:'dd MMM yyyy' }}</td>
              <td>{{ asset.user }}</td>
              <td class="text-end text-nowrap">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[asset.id]">
                  <i class="bi bi-pencil me-1"></i>Edit
                </a>
                @if (canDuplicate(asset)) {
                  <button class="btn btn-outline-secondary btn-sm ms-1" appConfirm (click)="duplicate(asset)">
                    <i class="bi bi-copy me-1"></i>Duplicate
                  </button>
                }
                <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(asset)">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
